import { GridLegacy as Grid } from '@mui/material'
import { PluralFacetFilter } from 'components/core/search-filter/facet'
import {
    AppUserServiceSearchRequest,
    GetUserSearchTermsRequest,
    AppUserSearchTerm,
} from 'pbts/c1/api/app/v1/app_user'
import React from 'react'
import { useIntl } from 'react-intl'
import { getAppUserSearchTerms } from 'redux_toolkit/app-users'

type AppUserOwnerFilterProps = {
    filter: AppUserServiceSearchRequest
    onChange: (updated: Partial<AppUserServiceSearchRequest>) => void
}

export const AppUserOwnerFilter: React.FC<AppUserOwnerFilterProps> = ({ filter, onChange }) => {
    const intl = useIntl()

    const noOwnerOption = {
        value: 'none',
        displayName: intl.formatMessage({
            id: 'app_user_filter_owner_no_owner',
            defaultMessage: 'No owner',
        }),
        iconUrl: '',
        count: -1,
    }

    return <Grid item>
        <PluralFacetFilter<GetUserSearchTermsRequest, 'userIds'>
            term={AppUserSearchTerm.IDENTITY_USER_IDS}
            hook={getAppUserSearchTerms.useLazyGetUserSearchTerms}
            filter={filter}
            filterKey="userIds"
            onChange={onChange}
            label={intl.formatMessage({
                id: 'app_user_filter_owner',
                defaultMessage: 'Owner',
            })}
            injectOption={noOwnerOption}
            widePopper
        />
    </Grid>
}
